import { db } from "@/firebase";
import { doc, getDoc } from "firebase/firestore";

const subscription = {
  state: {
    customer_id: null,
  },
  mutations: {
    setCustomerId(state, val) {
      state.customer_id = val;
    },
  },
  actions: {
    async fetchCustomerId({ commit, rootState }) {
      const customerId = await getDoc(
        doc(db, "customers", rootState.users.userProfile.uid),
      );
      if (customerId.exists()) {
        commit("setCustomerId", customerId.data().stripeId);
      } else {
        commit("setCustomerId", null);
      }
    },
  },
  getters: {},
};

export default subscription;
